module.exports = __webpack_public_path__ + "media/src/images/temp/iversity-buchmesse-books-image-342eb65372050b39a68de98ff8c66cfa.png";